//@ts-nocheck
import React, { useEffect, useMemo, useState } from 'react';
import {
  Box,
  Typography,
  Paper,
  Button,
  IconButton,
  Select,
  MenuItem,
  Menu,
  InputLabel,
  FormControl,
  TextField,
  Chip,
  createTheme,
  ThemeProvider,
  Autocomplete,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  useMediaQuery,
  CircularProgress,
  useTheme,
  Tooltip,
  Stack
} from '@mui/material';
import { createBooleanOperator, DatePickerControl, DateTimePickerControl, InputControl, NumericFormatInputControl } from '../../molecules';
import { useGetMerchantAccountHistory, useGetMerchantsWithParentMerchant, useGetMerchantCurrentBalanceTypeSettingsList, useMerchantCurrentBalanceMovement, GetMerchantAccountHistoryListRequest, useGetMerchantWithLatestMovementDetail, PagingResponse, useAuthorization, useMerchantCurrentBalanceMovementUpdate, useMerchantCurrentBalanceMovementDelete, useConfirmationModal, useGetListSettlementByDate } from '../../../hooks';
import { useSetSnackBar } from "../../../store/Snackbar.state";
import { Table } from '../../../components';
import {
  GridColDef,
  GridPaginationModel,
  GridValueFormatterParams,
} from "@mui/x-data-grid";
import dayjs from 'dayjs';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { useLocation } from 'react-router-dom';
import { downloadExcel } from "../../../util/downloadExcel";
import { ViewSidebar, ViewSidebarOutlined } from '@mui/icons-material';
import { RequestFilterOperationTypeEnum, RequestFilterValueTypeEnums, mapReactMUIToFilterOperationTypes, mapReactFilterValueTypeToRequestFilterValueType } from '../../../common/enums/RequestFilterEnums';
import { Loading } from '../../../components';
import MoreVertOutlined from '@mui/icons-material/MoreVertOutlined';
import { getGridSingleSelectOperators } from '@mui/x-data-grid-pro';
import * as zod from "zod";
import { DatePicker } from '@mui/x-date-pickers';

export const MerchantEndOfDayWithBalanceByDateFormRequestSchema = zod.object({
  paymentDate: zod.custom<dayjs.Dayjs>(
    (val) => dayjs.isDayjs(val) && val !== null,
    "Tarih zorunludur"
  )
})
  .refine(
    (data) => data.paymentDate.isValid(),
    {
      message: "Geçerli bir tarih giriniz",
      path: ["paymentDate"],
    }
  );

export type MerchantEndOfDayWithBalanceByDateFormRequest = zod.infer<
  typeof MerchantEndOfDayWithBalanceByDateFormRequestSchema
>;

export const MerchantEndOfDayWithBalanceByDateFormRequestInitValues: MerchantEndOfDayWithBalanceByDateFormRequest =
{
  paymentDate: dayjs().endOf('day'),
};

export const MerchantEndOfDayWithBalanceByDateComponent = ({ merchant }: any) => {

  const { control, handleSubmit, setValue, getValues } =
    useForm<MerchantEndOfDayWithBalanceByDateFormRequest>({
      resolver: zodResolver(MerchantEndOfDayWithBalanceByDateFormRequestSchema),
      defaultValues: MerchantEndOfDayWithBalanceByDateFormRequestInitValues,
    });

  const theme = useTheme();
  const { showDelete, showUpdate, showCreate } = useAuthorization();

  const [modalMode, setModalMode] = useState<'insert' | 'update'>('insert');
  const [selectedRow, setSelectedRow] = useState<any>(null);

  const { mutate: getListSettlementByDate, isLoading: isGetListSettlementByDateLoading } = useGetListSettlementByDate();

  var isPageLoading = isGetListSettlementByDateLoading;

  const setSnackbar = useSetSnackBar();
  interface QueryOptions {
    field?: string;
    value?: any;
    clearFilter?: boolean;
    [key: string]: string | number | boolean | undefined | any;
  }

  const [queryOptions, setQueryOptions] = React.useState<QueryOptions>({});
  const [paginationModel, setPaginationModel] = useState<GridPaginationModel>({
    page: 0,
    pageSize: 25,
  });

  const [tableData, setTableData] = useState<PagingResponse<Array<any>>>();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const location = useLocation();
  const [dynamicFilters, setDynamicFilter] = useState<any>([]);

  const debounce = (func: (...args: any[]) => void, delay: number) => {
    let timeoutId: NodeJS.Timeout;
    return (...args: any[]) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        func.apply(null, args);
      }, delay);
    };
  };

  interface FilterParams {
    [key: string]: string | number | boolean | null | undefined;
  }

  const getQueryParams = (filters: FilterParams) => {
    console.log("getQueryParams called with filters:", filters);
    const queryParams: { [key: string]: string | number | boolean } = {};

    for (let key in filters) {
      console.log('filter item', key);
      let value = filters[key];
      // Eğer gelen değer string "false" ise onu boolean false'a çevir
      if (value === "false") {
        queryParams[key] = false;
      }
      else if (key === 'isUserGoldBindingActive') {
        queryParams[key] = value === 2 ? 0 : 1;
      }
      else {
        if (value !== null && value !== undefined && value.toString().length > 0) {
          queryParams[key] = value;
        }
      }
    }
    return queryParams;
  };

  const handleFilterChange = debounce((filters, tableFilters) => {
    if (filters.clearFilter) {
      setDynamicFilter([]);
      return setQueryOptions({});
    }
    const queryParams = getQueryParams(filters);

    const isValueValid = (key: string, value: any): boolean => {
      if (key === 'installmentCount' || key === 'cardType' || key === 'selectedMonth' || key === 'totalCount' || key === 'totalChargeAmount' || key === 'isUserGoldBindingActive') { // Özel alan kontrolü
        return value?.toString().length >= 1;
      } else {
        return value?.toString().length >= 3;
      }
    }

    const allValuesValid = Object.entries(queryParams).every(([key, value]) => isValueValid(key, value));
    const previousKeysLength = Object.keys(previousQueryParams.current).length;
    const currentKeysLength = Object.keys(queryParams).length;

    if (JSON.stringify(previousQueryParams.current) === JSON.stringify(queryParams)) {
      return;
    }

    if (allValuesValid || (previousKeysLength > currentKeysLength)) {
      setQueryOptions(queryParams);
      setDynamicFilter(convertTableFiltersToRequestFilter(tableFilters));
    }


    // Son olarak, mevcut queryParams değerini bir önceki değer olarak set edin
    previousQueryParams.current = queryParams;

  }, 500);
  const hasActiveFilters = Object?.keys(queryOptions)?.length > 0;
  // Komponent içerisinde
  const previousQueryParams = React.useRef({});

  const [menuAnchorEl, setMenuAnchorEl] = useState<{ [key: string]: HTMLElement | null }>({});

  const booleanOptions = [
    { label: "Aktif", value: 1 },
    { label: "Pasif", value: 2 },
  ];

  const [paymentDate, setPaymentDate] = useState(dayjs().format("YYYY-MM-DD"));

  const columns: GridColDefExt[] = useMemo(() => {
    return [
      { field: 'merchantId', headerName: 'Üye No.', width: 120, columnType: RequestFilterValueTypeEnums.NUMBER },
      { field: 'merchantName', headerName: 'Üye İşyeri Adı', width: 250, columnType: RequestFilterValueTypeEnums.STRING, flex: 1 },
      {
        field: 'currencyDesc', headerName: 'Para Birimi', width: 100, columnType: RequestFilterValueTypeEnums.STRING
      },
      { field: 'paymentAmountBalance', headerName: 'Bakiye', width: 250, columnType: RequestFilterValueTypeEnums.NUMBER, type: 'decimal', filterable: false },
      {
        field: 'currentDate', headerName: 'Tarih', width: 100, columnType: RequestFilterValueTypeEnums.STRING, filterable: false, sortable: false,
        valueGetter: (params: GridValueFormatterParams) => {
          return dayjs(paymentDate).format("DD.MM.YYYY");
        }
      },
      {
        field: "isUserGoldBindingActive",
        headerName: "Altın Bağlantısı Aktif Mi?",
        width: 250,
        columnType: RequestFilterValueTypeEnums.NUMBER,
        filterOperators: [createBooleanOperator(booleanOptions)],
        renderCell: (params) => {
          const isDisabled = params.row.currency != "949";
          return (
            <Tooltip
              title={isDisabled ? 'Altın Bağlantı özelliği yalnızca TL hesapları için geçerlidir' : ''}
              arrow
              placement="top"
            >
              <div style={{
                cursor: isDisabled ? 'not-allowed' : 'default',
                opacity: isDisabled ? 0.5 : 1
              }}>
                {params.value && !isDisabled ? "Aktif" : "Pasif"}
              </div>
            </Tooltip>
          );
        }
      },
      {
        field: "totalGoldBinding",
        headerName: "Toplam Altın Bağlantısı",
        width: 250,
        columnType: RequestFilterValueTypeEnums.NUMBER,
        renderCell: (params) => {
          const isDisabled = params.row.currency != "949";
          return (
            <Tooltip
              title={isDisabled ? 'Altın Bağlantı özelliği yalnızca TL hesapları için geçerlidir' : ''}
              arrow
              placement="top"
            >
              <div style={{
                cursor: isDisabled ? 'not-allowed' : 'default',
                opacity: isDisabled ? 0.5 : 1
              }}>
                {params.value != null
                  ? parseFloat(params.value).toLocaleString("tr-TR", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }) : "0,00"} TL
              </div>
            </Tooltip>
          );
        }
      },
    ];
  }, [menuAnchorEl, showUpdate, showDelete, paymentDate]);

  const convertTableFiltersToRequestFilter = (tableFilters: any) => {

    let convertedFilters: any = [];

    tableFilters.items.map((item: any) => {
      var findColumn = columns.find(x => x.field == item.field);

      if (item.field === 'isUserGoldBindingActive') {
        // Preserve the original value in the filter dropdown
        convertedFilters.push({
          field: item.field,
          values: [item.value === 2 ? "0" : "1"],
          valueType: mapReactFilterValueTypeToRequestFilterValueType(item.value, findColumn?.columnType),
          operationType: mapReactMUIToFilterOperationTypes(item.operator)
        });
      } else {
        convertedFilters.push({
          field: item.field,
          values: [item.value.toString()],
          valueType: mapReactFilterValueTypeToRequestFilterValueType(item.value, findColumn?.columnType),
          operationType: mapReactMUIToFilterOperationTypes(item.operator)
        });
      }
    });
    return convertedFilters;
  }

  const handleChangePagination = (model: GridPaginationModel) => {
    setPaginationModel(model);
  };

  function fieldValue(data: any[]): Record<string, string | number | boolean | undefined>[] {
    return data.map((item) => {
      return {
        'Üye No.': item?.merchantId,
        'Üye İşyeri Adı': item?.merchantName,
        'Para Birimi': item?.currencyDesc,
        'Bakiye': item?.paymentAmountBalance,
        'Tarih': dayjs(paymentDate).format("DD.MM.YYYY"),
        'Altın Bağlantısı Aktif Mi?': item?.isUserGoldBindingActive ? "Aktif" : "Pasif",
        'Toplam Altın Bağlantısı': item?.totalGoldBinding
      };
    });
  }



  const onSubmit = (data: GetMerchantAccountHistoryListRequest) => {
    setPaymentDate(data.paymentDate);
  }

  const onSave = () => {
    if (dynamicFilters.find(x => x.field === "currencyDesc")) {
      dynamicFilters.find(x => x.field === "currencyDesc")!.field = "currency";
    }
    let payload = {
      filters: dynamicFilters,
      orderBy: "CreateDate",
      orderByDesc: true,
      page: paginationModel.page,
      size: paginationModel.pageSize,
      isExcel: true,
      paymentMerchantDate: dayjs(paymentDate).format("YYYY-MM-DD")
    };

    getListSettlementByDate(payload, {
      onSuccess: (data) => {
        if (data.isSuccess) {
          const refactoredData = fieldValue(data?.data?.result);
          downloadExcel(refactoredData || [], "cari-bakiye-raporu");
        } else {
          setSnackbar({
            severity: "error",
            description: "Bir hata oluştu.",
            isOpen: true,
          });
        }
      },
      onError: (error) => {
        setSnackbar({
          severity: "error",
          description: error.message || "Bir hata oluştu.",
          isOpen: true,
        });
      }
    });

  };

  useEffect(() => {

    if (dynamicFilters.find(x => x.field === "currencyDesc")) {
      dynamicFilters.find(x => x.field === "currencyDesc")!.field = "currency";
    }
    let payload = {
      filters: dynamicFilters,
      orderBy: "CreateDate",
      orderByDesc: true,
      page: paginationModel.page,
      size: paginationModel.pageSize,
      paymentMerchantDate: dayjs(paymentDate).format("YYYY-MM-DD")
    };

    getListSettlementByDate(payload, {
      onSuccess: (data) => {
        if (data.isSuccess) {
          setTableData(data?.data as PagingResponse<Array<any>>);
        } else {
          setTableData({});
          setSnackbar({
            severity: "error",
            description: "Bir hata oluştu.",
            isOpen: true,
          });
        }
      },
      onError: (error) => {
        setTableData({});
        setSnackbar({
          severity: "error",
          description: error.message || "Bir hata oluştu.",
          isOpen: true,
        });
      }
    });

  }, [paginationModel, queryOptions, dynamicFilters, paymentDate]);

  return (

    <ThemeProvider theme={theme}>
      {isPageLoading && <Loading />}
      <Box className="p-4" sx={{ p: 2 }}>

        <Stack
          direction="row"
          justifyContent="flex-end"
          alignItems="center"
          mb={2}
          spacing={2}
          sx={{ width: '100%' }}
        >
          <FormControl>
            <DatePickerControl
              sx={{ flex: 1, justifyContent: 'flex-end' }}
              id="paymentDate"
              control={control}
              label="Tarih"
              defaultValue={dayjs()} // Add default value
              format="YYYY-MM-DD"
            />
          </FormControl>
          <Button
            onClick={handleSubmit(onSubmit)}
            variant="contained"
            text={"ARA"}
          >
            ARA
          </Button>
        </Stack>

        {tableData && <Table
          filterKey="merchantPOSUsageFeeFilterKey"
          columnVisibilityConfigKey="merchantPOSUsageFeeFilterColumnVisibilityKey"
          hasActiveFilters={hasActiveFilters}
          handleFilterChange={handleFilterChange}
          paginationModel={paginationModel}
          onPaginationModelChange={handleChangePagination}
          paginationMode="server"
          rowCount={tableData?.totalItems || 0}
          isRowSelectable={() => false}
          customLabelDisplayedRows={true}
          autoHeight={false}
          getRowId={() => { return Math.floor(Math.random() * 100000) }}
          rows={tableData?.result || []}
          columns={columns}
          getRowClassName={(params: { row: { status: string } }) => {
            if (params.row.status === "PASSIVE") return "blocked-row";
            if (params.row.status === "BLOCKED") return "pasive-row";
            return "";
          }}
          exportFileName="Üye İşyeri POS Kullanım Bedeli Raporu"
          onSave={onSave}
        />}
      </Box>
    </ThemeProvider>
  );
};